import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { IItemFirmwareForAssign } from 'types';
import { firmwareTypes } from 'appConstants';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../../../../../firmwareAssignmentState/firmwareAssignmentContext';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import style from './Firmware.module.scss';

interface IFirmware {
	data: IItemFirmwareForAssign;
}

const Firmware: React.FC<IFirmware> = ({ data }) => {
	const { setIDsSelectedFirmware, IDsSelectedFirmware } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);
	const checkCheckbox = () => IDsSelectedFirmware.includes(data.id);
	const isCheckedCheckbox = useMemo(() => checkCheckbox(), [data, IDsSelectedFirmware]);
	const getFirmwareTypeName = () =>
		firmwareTypes.find((el) => el.firmwareTypeID === data.type)?.firmwareTypeName || null;
	const firmwareTypeName = useMemo(() => getFirmwareTypeName(), []);

	const containerClasses = classNames(style.container, {
		[style.hasAssign]: !data.unassigned,
		[style.checkedCheckbox]: isCheckedCheckbox,
	});

	const handleChange = (value: boolean) => {
		if (value) {
			setIDsSelectedFirmware([...IDsSelectedFirmware, data.id]);
		} else {
			const updateFirmwareList = IDsSelectedFirmware.filter((el) => el !== data.id);
			setIDsSelectedFirmware(updateFirmwareList);
		}
	};

	return (
		<div className={containerClasses} data-test="Firmware">
			<div className={style.name}>
				<Checkbox
					className={style.checkbox}
					onChange={(e) => handleChange(e.target.checked)}
					checked={isCheckedCheckbox}
				/>
				<Text translationKey={data.name} withTooltip={true} />
			</div>
			<Text className={style.type} translationKey={firmwareTypeName} withTooltip={true} />
		</div>
	);
};

export default Firmware;
